// AlertMessage.ts
import { v4 as uuidv4 } from "uuid";
import { store } from "../../../app/store";
import { addAlert } from "../../../features/ui/uiSlice";
import { JSX } from "react";
import { ErrorException, extractErrors } from "@common/helpers/error";

export const AlertMessage = (
  type: string,
  status: string | JSX.Element,
  context: string | undefined,
  text: string | JSX.Element,
  keep = false,
  source?: string,
) => {
  store.dispatch(
    addAlert({
      id: uuidv4(),
      type,
      status,
      text,
      context,
      keep,
      source,
    }),
  );
};

const getExceptionText = (t: (l: string) => string, x: unknown): string | null => {
  console.log("Caught exception", x);
  const err = extractErrors(x);
  if (err === null) {
    return null;
  }

  const translated_errors = err.map(x => x.label ? t(x.label) : null).filter(x => x !== null);
  if (translated_errors.length === 0) {
    return null;
  }

  return translated_errors.join(" | ");
};

export const report_exception = (t: (l: string) => string, x: unknown, contextLabel?: string) => {
  console.error(`Reported exception from ${contextLabel} context`, x);
  AlertMessage("danger", t("error_.label"), contextLabel, getExceptionText(t, x) ?? t("err_unknown_error_.label"));
};
